import { allUserRoles, UserRoleEnum } from '@/enums/userRolesEnum';

export interface SidebarLink {
    text: string;
    path: string;
    roles: UserRoleEnum[];
    hide?: boolean;
    divider?: boolean;
    subLinks?: SidebarLink[];
}

export const links: SidebarLink[] = [
	{
		text: 'Dashboard',
		path: 'dashboard',
		roles: allUserRoles,
		hide: true // Hide the dashboard for now
	},
	{
		text: 'Support Forms',
		path: 'support-forms',
		roles: [ UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER ],
		subLinks: [
			{
				text: 'Support Forms',
				path: 'support-form',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER]
			},
			{
				text: 'Comm Calendar',
				path: 'community-calendar',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER]
			},
			{
				text: 'Form Submissions',
				path: 'form-submissions',
				roles: [ UserRoleEnum.ADMIN, UserRoleEnum.VIEWER ],
			},
			{
				text: 'Forms',
				path: 'forms',
				roles: [UserRoleEnum.ADMIN]
			},
			{
				text: 'Email Logs',
				path: 'email-logs',
				roles: [UserRoleEnum.ADMIN]
			}
		]
	},
	{
		text: 'Public Website',
		path: 'public-site',
		roles: allUserRoles,
		subLinks: [

			{
				text: 'Member Alerts',
				path: 'member-alerts',
				roles: allUserRoles
			},
			{
				text: 'Website CMS',
				path: 'website-cms',
				roles: allUserRoles
			},
		]
	},

	{
		text: 'Scheduled Events',
		path: 'events',
		roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER],
		subLinks: [
			{
				text: 'Scheduled Events',
				path: 'scheduled-events',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT]
			},
			{
				text: 'Streams',
				path: 'streams',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.WEATHER]
			},
			{
				text: 'News Shows',
				path: 'news-shows',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.WEATHER]
			},
			{
				text: 'Generic Content',
				path: 'generic-content',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT]
			},
			{
				text: 'Teams',
				path: 'teams',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.WEATHER]
			},
			{
				text: 'Providers',
				path: 'providers',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.WEATHER]
			},
			// {
			// 	text: 'Channels',
			// 	path: 'channels',
			// 	roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.WEATHER]
			// }
		]
	},
	{
		text: 'DVD Orders',
		path: 'dvd',
		roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER],
		subLinks: [
			{
				text: 'DVD Orders',
				path: 'dvd-orders',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT]
			},
			{
				text: 'DVDs',
				path: 'dvds',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER]
			}
		]
	},

	{
		text: 'Products & Services',
		path: 'products-and-services',
		roles: [ UserRoleEnum.ADMIN ] ,
		subLinks: [
			{
				text: 'Display Details',
				path: 'display-details',
				roles: [ UserRoleEnum.ADMIN ]
			},
			{
				text: 'Discounts',
				path: 'discounts',
				roles: [ UserRoleEnum.ADMIN ]
			},
			{
				text: 'Cross Sales Admin',
				path: 'cross-sales',
				roles: [ UserRoleEnum.ADMIN ]
			},
			{
				text: 'CAT Items',
				path: 'cat-ids',
				roles: [ UserRoleEnum.ADMIN ]
			},
			{
				text: 'Terms',
				path: 'terms',
				roles: [ UserRoleEnum.ADMIN ]
			},
			{
				text: 'Digital TV Packages',
				path: 'digital-tv-packages',
				roles: [ UserRoleEnum.ADMIN ]
			}
		]
	},
	{
		text: 'Shopping Carts',
		path: 'shopping-carts',
		roles: [UserRoleEnum.ADMIN, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT],
		subLinks: [
			{
				text: 'Carts',
				path: 'carts',
				roles: [UserRoleEnum.ADMIN, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT]
			}
		]
	},
	{
		text: 'Reports',
		path: 'reports',
		roles: [ UserRoleEnum.ADMIN ],
		subLinks: [
			{
				text: 'Service Area',
				path: 'service-area-reports',
				roles: [ UserRoleEnum.ADMIN ],
			},
			{
				text: 'Service Address Queries',
				path: 'service-address-reports',
				roles: [ UserRoleEnum.ADMIN ]
			},
		]
	},
];

if (process.env.VUE_APP_SHOW_WEATHER === 'true') {
	links.push(...[
		{
			text: 'Weather',
			path: 'weather',
			roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER],
			subLinks: [
				{
					text: 'Live Cameras',
					path: 'live-cameras',
					roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER]
				},
				{
					text: 'Maps',
					path: 'maps',
					roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER]
				},
				{
					text: 'Weather News Story',
					path: 'news-stories',
					roles: [UserRoleEnum.ADMIN, UserRoleEnum.VIEWER, UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT, UserRoleEnum.WEATHER]
				},
			]
		},
	]);
}

links.push(...[
	{
		text: '',
		path: 'settings-divider',
		roles: allUserRoles,
		divider: true
	},
	{
		text: 'Settings',
		path: 'settings',
		roles: allUserRoles,
	},
	{
		text: 'Logout',
		path: 'login',
		roles: allUserRoles,
	}
]);